import toast from "react-hot-toast";
import { getErrorFromCatch, serializeFieldErrors } from "../services/api";
import { magentoApi } from "../services/magento.api";

export default function useMagento() {

  const [toGetCategoriesApi] = magentoApi.useLazyGetCategoriesQuery();


  // --
  // -- return: null - OK, { error? } - Error
  // --
  const getCategories = async (): Promise<unknown> => {
    try {
      const data = await toGetCategoriesApi({}).unwrap();
      console.log('categories = ', data);
      
      return null;
    } catch (err) {      
      toast.error(`${getErrorFromCatch(err)}`, { duration: 8000 });           
      return serializeFieldErrors(err) ?? { email: getErrorFromCatch(err) };
    }
  }

  return {
    getCategories,
  };
}